












































































import Vue, { PropType } from 'vue';
import {
  IInvoiceItem,
  InvoiceStateEnum,
  PaymentPlanAmountTypeEnum
} from '@/models';

export default Vue.extend({
  name: 'InvoiceDetailSummaryItemsTableItems',
  props: {
    currencyCode: {
      type: String,
      required: true
    },
    state: {
      type: Number as PropType<InvoiceStateEnum>,
      required: true
    },
    amount_type: {
      type: Number,
      required: true
    },
    invoiceItems: {
      type: Array as PropType<IInvoiceItem[]>,
      required: true
    }
  },
  computed: {
    jcmiIcon(): string {
      return require('@/assets/logos/jamesway_mini_logo.png');
    }
  },
  data() {
    return {
      PaymentPlanAmountTypeEnum,
      InvoiceStateEnum
    };
  }
});
